// Player-facing strings of the boot shell (the loading and fail screens, shown before the content and its strings
// table load). The flow's screens (title, pause, game over, the mid-game loader) moved to @rpg/ui in gate A4.2 and
// take their text from the strings table (content/tables/strings.json). Nothing on these screens is written anywhere
// else.

export const STRINGS = {
  "boot.loadingTitle": "Green Valley",
  "boot.step.rapier": "Loading physics",
  "boot.step.recast": "Loading navigation",
  "boot.step.world": "Building the valley",
  "boot.step.vfx": "Lighting the sparks",
  "boot.step.warm": "Preparing shaders",
  "boot.fail.title": "The valley couldn't load",
  "boot.fail.noWebGL2": "This browser can't run WebGL2, which the game needs. Try a recent Chrome, Edge, Firefox or Safari.",
  "boot.fail.error": "Something went wrong while starting:",
  "boot.fail.details": "Details",
  "boot.fail.reload": "Reload",
  "loading.step.zone": "Waking the valley",
} as const;

/** A string key. */
export type StringKey = keyof typeof STRINGS;

/** The string for a key. */
export const t = (k: StringKey): string => STRINGS[k];
